// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__m63_e","enumerated":"list_enumerated__lVXNl"};